import React from "react";
import MultiCarousel from "../CustomCarousel/MultiCarousel";
import "./index.css";
import customLeftArrow from "../../assets/design-revamp-product/product-icons/leftArrow.svg";
import customRightArrow from "../../assets/design-revamp-product/product-icons/rightArrow.svg";

const ProductCarousel = ({ products, children, subgroup }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const CustomLeftArrow = ({ onClick }) => (
    <div
      onClick={onClick}
      style={{
        position: "absolute",
        left: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 10,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-50%) scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(-50%) scale(1)";
      }}
    >
      <img
        src={customLeftArrow}
        alt="Previous"
        style={{ width: "24px", height: "24px", pointerEvents: "none" }}
      />
    </div>
  );

  const CustomRightArrow = ({ onClick }) => (
    <div
      onClick={onClick}
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 10,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "translateY(-50%) scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "translateY(-50%) scale(1)";
      }}
    >
      <img
        src={customRightArrow}
        alt="Next"
        style={{ width: "24px", height: "24px", pointerEvents: "none" }}
      />
    </div>
  );

  // Get the total number of items
  const totalItems = React.Children.count(children);

  // Determine if we need a carousel (more items than can fit on desktop)
  const needsCarousel = totalItems > responsive.desktop.items;

  if (!needsCarousel) {
    return (
      <div
        className="static-product-container"
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          justifyContent: "flex-start",
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <MultiCarousel
        responsive={responsive}
        infinite={true}
        containerClass="product-carousel-container"
        itemClass="product-carousel-item"
        customLeftArrow={<CustomLeftArrow />}
        customRightArrow={<CustomRightArrow />}
      >
        {children}
      </MultiCarousel>
    </div>
  );
};

export default ProductCarousel;
